import { getIconComponent } from '../../utils/getIconComponent';
import { isFieldRestricted } from 'customer-data-filters-ui/utils/fieldLevelPermissions';
import RestrictedPropertyIcon from 'customer-data-filters-ui/components/common/RestrictedPropertyIcon';
import StyledEditorOptionBase from './StyledEditorOptionBase';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { InfoIcon } from 'foundations-assets';
import UITruncateString from 'UIComponents/text/UITruncateString';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import { PropertyInformationPopoverContent } from '../propertyInformationPopoverContent/PropertyInformationPopoverContent';
import { View } from 'foundations-components/components/View';
import { hasPropertyInformationPopover } from '../../permissions/gates';
import { ObjectTypeIdRegex } from '../../filterQueryFormat/ObjectTypeId';
import { Metrics } from '../../metrics/Metrics';
import { Flex } from 'foundations-components/components/Flex';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const trackPropertyInformationPopoverOpenDuration = openTimeMillis => {
  Metrics.timer('prop_info_pop_open_duration').update(performance.now() - openTimeMillis);
};
const EditorFieldOption = ({
  field,
  filterFamily,
  onClick
}) => {
  var _getIconComponent;
  const {
    accessLevel,
    disabled,
    displayName,
    name,
    tooltip
  } = field;
  const isRestricted = isFieldRestricted(accessLevel);
  const {
    getIsUngated
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    IconComponent
  } = (_getIconComponent = getIconComponent(field, getIsUngated, filterFamily)) !== null && _getIconComponent !== void 0 ? _getIconComponent : {};
  const [propertyInformationPopoverShown, setPropertyInformationPopoverShown] = useState(false);
  const [hovered, setHovered] = useState(false);
  const onMouseEnter = useCallback(() => {
    setHovered(true);
  }, []);
  const onMouseLeave = useCallback(() => {
    setHovered(false);
    setPropertyInformationPopoverShown(false);
  }, []);
  const propertyInformationPopoverHovered = useCallback(() => {
    setPropertyInformationPopoverShown(true);
  }, []);
  const propertyInformationPopoverOpenTime = useRef();
  useEffect(() => {
    if (propertyInformationPopoverShown && typeof propertyInformationPopoverOpenTime.current === 'undefined') {
      // Property Information Popover is open and we haven't yet stored an openTime
      //   store the current time as the openTime
      propertyInformationPopoverOpenTime.current = performance.now();
    }
    if (!propertyInformationPopoverShown && typeof propertyInformationPopoverOpenTime.current !== 'undefined') {
      // Property Information Popover is closed and we haven't yet tracked the openDuration
      //   record the metric and clear the openTime
      trackPropertyInformationPopoverOpenDuration(propertyInformationPopoverOpenTime.current);
      propertyInformationPopoverOpenTime.current = undefined;
    }
  }, [propertyInformationPopoverShown]);
  useEffect(() => {
    return () => {
      if (typeof propertyInformationPopoverOpenTime.current !== 'undefined') {
        // The component is being unmounted but the last open duration was not recorded
        trackPropertyInformationPopoverOpenDuration(propertyInformationPopoverOpenTime.current);
        propertyInformationPopoverOpenTime.current = undefined;
      }
    };
  }, []);
  const isObjectOrUnifiedEventProperty = ObjectTypeIdRegex.test(filterFamily);
  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: !disabled,
    placement: "left",
    title: tooltip,
    children: /*#__PURE__*/_jsx(StyledEditorOptionBase, {
      "data-onboarding": "filter-property-option",
      "data-selenium-info": name,
      "data-selenium-test": "fr-field-option",
      disabled: disabled,
      onClick: onClick,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [IconComponent && /*#__PURE__*/_jsx(IconHolder, {
          color: "icon-primary-disabled",
          size: "500",
          paddingBlock: "0",
          icon: IconComponent
        }), /*#__PURE__*/_jsx(UITruncateString, {
          useFlex: isRestricted,
          fixedChildren: isRestricted ? /*#__PURE__*/_jsx(IconHolder, {
            paddingBlock: "0",
            icon: RestrictedPropertyIcon
          }) : undefined,
          children: displayName
        }), isObjectOrUnifiedEventProperty && hovered && hasPropertyInformationPopover() && /*#__PURE__*/_jsx(UIPopover, {
          placement: "right bottom",
          open: propertyInformationPopoverShown,
          closeOnTargetLeave: true,
          onOpenChange: event => setPropertyInformationPopoverShown(event.target.value),
          content: {
            body: /*#__PURE__*/_jsx(View, {
              inlineSize: "350px",
              children: /*#__PURE__*/_jsx(PropertyInformationPopoverContent, {
                filterFamily: filterFamily,
                propertyName: field.name
              })
            })
          },
          children: /*#__PURE__*/_jsx(IconHolder, {
            color: "icon-core-subtle",
            size: "400",
            paddingBlock: "0",
            marginInlineEnd: "200",
            icon: InfoIcon,
            onMouseEnter: propertyInformationPopoverHovered
          })
        })]
      })
    })
  });
};
export default EditorFieldOption;